import { sendVerifyEmail, signOut } from "./account"

export function isEmailVerified(user) {
    if (user) {
        console.log("user Email Verified:", user.emailVerified)
        if(!user.emailVerified){
            const element = `
                <div class="cantClosePopup" id="emailVerify">
                    <div class="popupBox">
                        <h1 class="popupTitle">VERIFY YOUR EMAIL</h1>
                        <span class="popupDescription">
                            You will need to verifiy your email before you can pay for things.
                        </span>
                        <span class="popupDescription">
                            Please click on the link in your email from An Average Game.
                        </span>
                        <span class="popupDescription">
                            Then refresh this page.
                        </span>
                        <div id="sendAgain"><button id="sendLink" class="btn">Send Another Link</button></div>
                        <button id="verifyLater" class="btn" style="">Verify Later</button>
                    </div>
                </div>
            `
            document.body.insertAdjacentHTML('afterbegin',element)
            document.getElementById("emailVerify").style.visibility = "visible"
            document.getElementById("sendLink").addEventListener("click",()=>{
                sendVerifyEmail(user)
                document.getElementById("sendAgain").innerHTML = '<span id="emailSent">Email Sent</span>'
            })
            document.getElementById("verifyLater").addEventListener("click",()=>{
                document.getElementById("emailVerify").style.visibility = "hidden"
            })
        }
    }
}